import {FaSearchDollar} from 'react-icons/fa'
import {defineType} from 'sanity'
import {dotcomDocument, dotcomDocuments} from '../fragments/dotcom.document'
import {cruiseGroups} from '@/lib/cruiseGroups'

export default defineType({
  name: 'cruise-filters',
  type: 'object',
  icon: FaSearchDollar,
  fields: [
    {
      name: 'filterByShip',
      title: 'Filter by Ship',
      type: 'array',
      of: [dotcomDocument('ship')],
    },
    {
      name: 'filterByDestination',
      title: 'Filter by Destination',
      type: 'array',
      of: [dotcomDocument('destination')],
    },
    {
      name: 'filterByCruiseGroups',
      title: 'Filter by Cruise Groups',
      type: 'array',
      of: [
        {
          type: 'string',
        },
      ],
      options: {
        list: cruiseGroups,
      },
    },
    // {
    //   name: "filterByFareCodes",
    //   title: "Filter by Fares",
    //   type: "array",
    //   of: [
    //     {
    //       type: "string"
    //     }
    //   ],
    //   options: {
    //     list: fareCodes
    //   }
    // },
    {
      name: 'filterByCruiseType',
      title: 'Filter by Cruise Type',
      description: 'Leave empty for all',
      type: 'array',
      of: [{type: 'string'}],
      options: {
        list: [
          {title: 'Classic', value: 'Classic'},
          {title: 'Expedition', value: 'Expedition'},
        ],
      },
    },
    {
      name: 'filterByComboType',
      title: 'Filter by Combo Type',
      description: 'Leave empty for all',
      type: 'array',
      of: [{type: 'string'}],
      options: {
        list: [
          {title: 'Single', value: 'Single'},
          {title: 'Combo', value: 'Combo'},
          {title: 'World', value: 'World'},
          {title: 'Grand', value: 'Grand'},
        ],
      },
    },
    {
      name: 'filterByCruise',
      title: 'Filter by Cruise',
      type: 'array',
      of: [dotcomDocuments(['cruise', 'specialVoyage'])],
    },
    {
      name: 'filterByLandProgrammes',
      title: 'Filter by Land Programmes',
      type: 'array',
      of: [dotcomDocument('landProgramme')],
    },
    {
      name: 'filterByCountries',
      title: 'Filter by Countries',
      type: 'array',
      of: [dotcomDocument('country')],
    },
    {
      name: 'filterByPorts',
      title: 'Filter by Ports',
      type: 'array',
      of: [dotcomDocument('port')],
    },
    // {
    //   name: "filterByFeatures",
    //   title: "Filter by Features",
    //   description: "Leave empty for all",
    //   type: "array",
    //   of: [{ type: "string" }],
    //   options: {
    //     list: [
    //       { title: "Bridge Sailings", value: "BridgeSailings" },
    //       { title: "Gentlemen Hosts", value: "GentlemenHosts" },
    //       { title: "Culinary Voyages", value: "CulinaryVoyages" },
    //       { title: "Wine Cruises", value: "WineCruises" }
    //     ]
    //   }
    // },
    {
      name: 'filterByCruiseTagCategories',
      title: 'Filter by Cruise Tag Categories',
      type: 'array',
      of: [dotcomDocument('cruisesTagCategory')],
    },
    {
      name: 'filterByDepartureYearsAndMonths',
      title: 'Filter by Departure Years and Months',
      type: 'array',
      of: [{type: 'fycYearMonthFilter'}],
    },
  ],
})
